import Footer from '../Components/Footer';
import Topic from '../Components/ForumComp/Topic';
import Header from '../Components/Header';
//import './TopicPage.css';

function TopicPage() {

    return (
        <div>
            <Header/>
            <Topic/>
            <Footer/>
        </div>
    );
}

export default TopicPage;